import React, { ForwardedRef, useImperativeHandle, useRef } from 'react';
import Chart from '..';
import { LineChartProps, ChartRef } from '../_config/interface';
import { makeupOptions } from '../_config/utils';
import { getDataIndexList, getOffset } from '@/pages/dashboard/components/Chart/_config/plug';
import { numFormat } from '@/pages/dashboard/utils/utils';

const BarChartInner: React.ForwardRefRenderFunction<ChartRef, LineChartProps> = (props, ref: ForwardedRef<ChartRef>) => {
  const {
    className = '',
    style = {},
    height,
    chartEventConfig,
    notMerge,
    isStackBar,
    fixNumber = 0,
  } = props;
  const chartRef = useRef<ChartRef>(null);
  const option = makeupOptions(props, 'bar');

  const calculateTotal = (event: any) => {
    const eventSelected = event.selected;
    const optionSeries = option.series;

    const newTotalData = Array(optionSeries[0].data.length).fill(0);
    option.series.slice(0, option.series.length - 1).forEach(optionSeries => {

      // eslint-disable-next-line no-prototype-builtins
      if (eventSelected.hasOwnProperty(optionSeries.name) && eventSelected[optionSeries.name]) {
        optionSeries.data.forEach((data, index) => {
          newTotalData[index] += parseFloat(data) || 0;
        });
      }

    });

    const newFormattedTotalData = newTotalData.map(data => numFormat(data.toFixed(fixNumber || 0)));
    const indexList = getDataIndexList(newTotalData);
    option.series[option.series.length - 1].label.formatter = (params) => {
      if (indexList.includes(params.dataIndex) && newTotalData[params.dataIndex] > 0) {
        return newFormattedTotalData[params.dataIndex];
      } else {
        return '';
      }
      // const numBars = option.series[option.series.length - 1].data.length;
      //
      // if (numBars > 12) {
      //     const interval = Math.floor((numBars - 1) / 8);
      //
      //     if (params.dataIndex % interval === 0 && (newFormattedTotalData[params.dataIndex] !== (0 || '0'))) {
      //         return newFormattedTotalData[params.dataIndex];
      //     } else {
      //         return '';
      //     }
      // } else {
      //     if ((newFormattedTotalData[params.dataIndex] !== (0 || '0'))) {
      //         return newFormattedTotalData[params.dataIndex];
      //     } else {
      //         return '';
      //     }
      // }
    };
    return option;
  };

  if (isStackBar) {
    // Check if option is valid
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (option && option.series) {
      // const stackName = (option.series && option.series[0].stack)
      //   ? option.series[0].stack : 'Total';
      const stackName = 'Total';
      const seriesData = option.series.map((series) => series.data) || [];

      // Check if seriesData is valid and has data
      if (seriesData && seriesData.length > 0 && seriesData[0]) {
        const totalData = Array.from({ length: seriesData[0].length || 0 }, () => 0) || 0;

        for (const data of seriesData) {
          for (let i = 0; i < data.length; i++) {
            totalData[i] += parseFloat(data[i] || 0);
          }
        }
        const newFormattedTotalData = totalData.map(data => numFormat(data.toFixed(fixNumber || 0)));
        const indexList = getDataIndexList(totalData);
        const newData = newFormattedTotalData?.map((item, index) => {
          return {
            value: 0,
            label: {
              offset: getOffset(item, index, newFormattedTotalData),
            },
          };
        });
        // Push the new stack onto the current bar chart
        option.series.push({
          name: stackName,
          type: 'bar',
          stack: stackName, // Set the stack name here
          cursor: 'pointer',
          color: '#fff',
          barGap: '-100%',
          // data: totalData.map(() => 0), // Set bar data to 0
          data: newData, // Set bar data to 0
          label: {
            show: true, // Always show labels
            position: 'top',
            color: '#525464',
            formatter: (params: any) => {
              if (indexList.includes(params.dataIndex) && totalData[params.dataIndex] > 0) {
                return newFormattedTotalData[params.dataIndex];
              } else {
                return '';
              }
              // const numBars = option.series[option.series.length - 1].data.length;
              //
              // if (numBars > 12) {
              //     const interval = Math.floor((numBars - 1) / 8);
              //
              //     if (params.dataIndex % interval === 0 && (newFormattedTotalData[params.dataIndex] !== (0 || '0'))) {
              //         return newFormattedTotalData[params.dataIndex];
              //     } else {
              //         return '';
              //     }
              // } else {
              //     if ((newFormattedTotalData[params.dataIndex] !== (0 || '0'))) {
              //         return newFormattedTotalData[params.dataIndex];
              //     } else {
              //         return '';
              //     }
              // }
            },
          },
          // labelLayout(params) {
          //     const lastIndex = indexList[0];
          //     console.log(params, indexList);
          //     if (params.dataIndex === lastIndex && totalData[lastIndex] > 999) {
          //         return {
          //             x: params.rect.x + params.rect.width + 4,
          //             y: params.rect.y - 20,
          //             align: 'right'
          //         }
          //     }
          //     return {
          //     }
          // }
        });
      } else {
        // console.error("Series data is empty or invalid.");
      }
    } else {
      // console.error("Option or series is undefined or invalid.");
    }
  }

  // 刷新图表
  const refreshChart = () => {
    instance()?.setOption(option);
  };

  // 获取实例
  const instance = () => {
    return chartRef?.current?.instance();
  };

  // 对父组件暴露的方法
  useImperativeHandle(ref, () => ({
    instance,
    refreshChart
  }));

  const chartStyle = {
    ...(height ? { height: `${height}px` } : {}),
    width: '100%',
    ...style
  };

  return (
    <div className={`chart-box ${className}`} style={chartStyle}>
      <Chart
        ref={chartRef}
        option={option}
        chartEventConfig={chartEventConfig}
        notMerge={notMerge}
        calculateTotal={isStackBar ? calculateTotal : null}
      />
    </div>
  );
};

const BarChart = React.forwardRef(BarChartInner);

export default BarChart;
